import { render } from "./SignUp.vue?vue&type=template&id=7cada87a&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"

import "./SignUp.vue?vue&type=style&index=0&id=7cada87a&scoped=true&lang=css"

import exportComponent from "D:\\Trabajo\\Raxar\\backoffice-base-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cada87a"]])

export default __exports__